import { PersonBusinessSchema } from 'services/persons';
import { config } from 'config';

export enum DomainType {
  paya = 'paya',
  freightx = 'freightx',
  invoicecloud = 'invoicecloud',
  smartHub = 'smartHub',
}

export const getSubDomain = () => {
  if (['localhost', '127.0.0.1', ''].includes(window.location.hostname)) {
    return config.DEFAULT_SUBDOMAIN;
  }

  return window.location.host;
};

export const domain = () => {
  const domainKeys: string[] = Object.keys(DomainType);
  const subDomain: string = getSubDomain();

  return (
    domainKeys.find((key) => subDomain.includes(key)) ?? DomainType.smartHub
  );
};

export const setFavicon = (href: string) => {
  const favicon: HTMLLinkElement | null =
    document.querySelector('link[rel~="icon"]');

  if (favicon) {
    favicon.href = href;
  }
};

export const isSmartHubDomain = () =>
  getSubDomain().includes(config.SMART_HUB_DOMAIN);

export const getRedirectTenantLink = (business: PersonBusinessSchema) => {
  if (
    business?.businessesTenantUrlSub &&
    getSubDomain() !== business?.businessesTenantUrlSub &&
    !isSmartHubDomain()
  ) {
    return `${config.PROTOCOL}${business.businessesTenantUrlSub}/login`;
  }

  return '';
};

export const isUATDomain = () => {
  const subDomain = getSubDomain();

  return (
    subDomain.indexOf('uat') === 0 || subDomain.indexOf('enroll-uat') === 0
  );
};

// email-code (OTP) login only works on a smart-enroll.com host: its session cookie is SameSite and the API is
// (uat)api.smart-enroll.com, so a smart-hub.com page never gets to keep it. Not DEFAULT_SUBDOMAIN: the prod build
// leaves it as the UAT value.
const getOtpUrl = (
  pathname: string,
  login: { email?: string; phone?: string },
) => {
  const smartEnrollHost = isUATDomain()
    ? 'uat.smart-enroll.com'
    : 'smart-enroll.com';
  const params = new URLSearchParams();
  if (login.email) {
    params.set('email', login.email);
  }
  if (login.phone) {
    params.set('phone', login.phone);
  }
  const query = params.toString();

  return `${config.PROTOCOL}${smartEnrollHost}${pathname}${
    query ? `?${query}` : ''
  }`;
};

export const getOtpLoginUrl = (login: { email?: string; phone?: string }) =>
  getOtpUrl('/login', login);

// same, for someone starting on the sign-up page
export const getOtpEnrollUrl = (login: { email?: string }) =>
  getOtpUrl('/enroll', login);
